import { z } from "zod";

export const IdParamSchema = z.object({ id: z.string().min(1) });
export type IdParamDTO = z.infer<typeof IdParamSchema>;

export const EventIdParamSchema = z.object({ eventId: z.string().min(1) });
export type EventIdParamDTO = z.infer<typeof EventIdParamSchema>;

export const AssignmentParamSchema = z.object({
  eventId: z.string().min(1),
  assignmentId: z.string().min(1),
});
export type AssignmentParamDTO = z.infer<typeof AssignmentParamSchema>;

export const RateParamSchema = z.object({
  id: z.string().min(1),
  rateId: z.string().min(1),
});
export type RateParamDTO = z.infer<typeof RateParamSchema>;

export const LookupQuerySchema = z.object({
  q: z
    .string()
    .trim()
    .transform((v) => (v && v.length > 0 ? v : undefined))
    .optional(),
  limit: z.coerce.number().int().min(1).max(100).default(20),
  skip: z.coerce.number().int().min(0).default(0),
});
export type LookupQueryDTO = z.infer<typeof LookupQuerySchema>;

export const EventKindSchema = z.enum([
  "stage_show",
  "mv_shoot",
  "film_ad",
  "content",
  "kol",
  "mixed",
]);
export type EventKind = z.infer<typeof EventKindSchema>;

export const BillingModeSchema = z.enum(["performance", "manual"]);
export type BillingMode = z.infer<typeof BillingModeSchema>;

export const PayoutKindSchema = z.enum([
  "performer",
  "staff",
  "production",
  "outsource",
]);
export type PayoutKind = z.infer<typeof PayoutKindSchema>;

export const OutsourcePayeeTypeSchema = z.enum(["individual", "team"]);
export type OutsourcePayeeType = z.infer<typeof OutsourcePayeeTypeSchema>;

export const RoleKindSchema = z.enum([
  "dancer",
  "choreographer",
  "kol",
  "mc",
  "other",
]);
export type RoleKind = z.infer<typeof RoleKindSchema>;
